import { render, staticRenderFns } from "./DokumenKelayakan.vue?vue&type=template&id=bd77f472"
import script from "./DokumenKelayakan.vue?vue&type=script&lang=js"
export * from "./DokumenKelayakan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports